import React from 'react'

export const Download = () => {
  return (
    <object
                                                
                                                        data="https://websalsign.s3.amazonaws.com/8208/77777777-7/9-295078-2.pdf"
                                                        type="application/pdf" width="100%" height="100%"></object>
  )
}
